/* Action Types */
export const CALL_SEND_INVITES = 'CALL_SEND_INVITES';
export const SEND_INVITES_FAILED = 'SEND_INVITES_FAILED';
export const SEND_INVITES_SUCCESS = 'SEND_INVITES_SUCCESS';

/* Action Creators */
export function sendInvites(invites) {
  return { type: CALL_SEND_INVITES, invites };
}

export function sendInvitesFailed(error) {
  return { type: SEND_INVITES_FAILED, error };
}

export function sendInvitesSuccess() {
  return { type: SEND_INVITES_SUCCESS };
}

const INITIAL_STATE = {
  loading: {
    save: false
  }
}

/* Reducer */
export default function reducer(state = INITIAL_STATE, action) {

  const { type } = action;

  switch(type) {
    case CALL_SEND_INVITES:
      return {
        ...state,
        loading: {
          ...state.loading,
          save: true
        }
      };
    case SEND_INVITES_FAILED:
      return {
        ...state,
        loading: {
          ...state.loading,
          save: false
        }
      };
    case SEND_INVITES_SUCCESS:
      return {
        ...state,
        loading: {
          ...state.loading,
          save: false
        }
      };
    default:
      return state;
  }

}



// WEBPACK FOOTER //
// ./src/ducks/InvitesDucks.js